var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-overlay", { attrs: { show: _vm.in_progress } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-3" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("label", { staticClass: "text-muted" }, [
              _vm._v("Filtrar por estado de origen/destino"),
            ]),
            _vm._v(" "),
            _c("b-form-select", {
              attrs: { options: _vm.opciones_estados_republica, size: "sm" },
              model: {
                value: _vm.configuracion_buesqueda.filtros.ISO,
                callback: function ($$v) {
                  _vm.$set(_vm.configuracion_buesqueda.filtros, "ISO", $$v)
                },
                expression: "configuracion_buesqueda.filtros.ISO",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { staticClass: "text-muted" }, [
              _vm._v("Filtrar solicitudes locales/foráneas"),
            ]),
            _vm._v(" "),
            _c("b-form-select", {
              attrs: { options: _vm.opciones_ambito_solicitudes, size: "sm" },
              model: {
                value: _vm.configuracion_buesqueda.filtros.ambito,
                callback: function ($$v) {
                  _vm.$set(_vm.configuracion_buesqueda.filtros, "ambito", $$v)
                },
                expression: "configuracion_buesqueda.filtros.ambito",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { staticClass: "text-muted" }, [
              _vm._v("Filtrar por cubicaje [m"),
              _c("sup", [_vm._v("3")]),
              _vm._v("]"),
            ]),
            _vm._v(" "),
            _c("b-form-select", {
              attrs: { options: _vm.opciones_cubicaje, size: "sm" },
              model: {
                value: _vm.configuracion_buesqueda.filtros.m3,
                callback: function ($$v) {
                  _vm.$set(_vm.configuracion_buesqueda.filtros, "m3", $$v)
                },
                expression: "configuracion_buesqueda.filtros.m3",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { staticClass: "text-muted" }, [
              _vm._v("Ordenar solicitudes"),
            ]),
            _vm._v(" "),
            _c("b-form-select", {
              attrs: { options: _vm.opciones_orden_solicitudes, size: "sm" },
              model: {
                value: _vm.configuracion_buesqueda.ordenamientos,
                callback: function ($$v) {
                  _vm.$set(_vm.configuracion_buesqueda, "ordenamientos", $$v)
                },
                expression: "configuracion_buesqueda.ordenamientos",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", [_vm._v("Categoría")]),
            _vm._v(" "),
            _c(
              "b-form-checkbox",
              {
                attrs: { value: "1", "unchecked-value": "0" },
                model: {
                  value: _vm.configuracion_buesqueda.filtros.preventa,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.configuracion_buesqueda.filtros,
                      "preventa",
                      $$v
                    )
                  },
                  expression: "configuracion_buesqueda.filtros.preventa",
                },
              },
              [_vm._v("\n          Pre-venta\n        ")]
            ),
            _vm._v(" "),
            _c(
              "b-form-checkbox",
              {
                attrs: { value: "1", "unchecked-value": "0" },
                model: {
                  value: _vm.configuracion_buesqueda.filtros.compartida,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.configuracion_buesqueda.filtros,
                      "compartida",
                      $$v
                    )
                  },
                  expression: "configuracion_buesqueda.filtros.compartida",
                },
              },
              [_vm._v("\n          Mudanza compartida\n        ")]
            ),
            _vm._v(" "),
            _c(
              "b-form-checkbox",
              {
                attrs: { value: "1", "unchecked-value": "0" },
                model: {
                  value:
                    _vm.configuracion_buesqueda.filtros.numero_cotizaciones,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.configuracion_buesqueda.filtros,
                      "numero_cotizaciones",
                      $$v
                    )
                  },
                  expression:
                    "configuracion_buesqueda.filtros.numero_cotizaciones",
                },
              },
              [_vm._v("\n          Sin cotizaciones\n        ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 d-block d-sm-none" }, [_c("hr")]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-9" },
        [
          _vm.solicitudes_filtradas.length == 0
            ? _c("div", { staticClass: "row text-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "jumbotron bg-white" }, [
                    _c(
                      "h1",
                      {
                        staticClass: "display-4",
                        staticStyle: { "font-size": "1.8em" },
                      },
                      [
                        _vm._v(
                          "\n              No hay solicitudes con el criterio de búsqueda que usaste\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "lead" }, [
                      _vm._v("Prueba con otros filtros de búsqueda"),
                    ]),
                  ]),
                ]),
              ])
            : _vm.solicitudes.length > 0
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 mb-3" }, [
                  _c("h5", { staticClass: "text-info" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.solicitudes_filtradas.length) +
                        "/\n            " +
                        _vm._s(_vm.solicitudes.length) +
                        "\n            solicitudes para comprar\n          "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "transition-group",
            { staticClass: "row", attrs: { name: "list-complete" } },
            _vm._l(_vm.solicitudes_filtradas, function (s, index) {
              return _c(
                "div",
                { key: s.id_mm, staticClass: "col-12 mb-3 list-complete-item" },
                [_c("card-solicitud", { attrs: { s: s, index: index } })],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }